const removeJavascriptOnDeleteComp = (editor) => {
  editor.on('run:command-clear-canvas:before', () => {
    editor.Commands.run('enable-clear-page');
  });

  editor.on('component:remove', (component) => {
    if (
      editor.Commands.isActive('enable-delete-page') === false &&
      editor.Commands.isActive('enable-navigate-page') === false &&
      editor.Commands.isActive('enable-clear-page') === false
    ) {

      const compId = component.attributes.attributes.id;

      const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
      const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
      const tempData = JSON.parse(localStorage.getItem('data'));
      const { javascript } = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[
        selectedPage
      ];

      const jsFunctionToRemove = javascript.functions?.filter(
        (jsFunction) => jsFunction.compId === compId
      );
      if (jsFunctionToRemove && jsFunctionToRemove.length > 0) {
        const cleanJsFunctions = javascript.functions.filter(
          (jsFunction) => jsFunction.compId !== compId
        );
        tempData[selectedProject].pages[selectedPage].javascript.changeJavascript = true;
        tempData[selectedProject].pages[selectedPage].javascript.functions = cleanJsFunctions;
        localStorage.setItem('data', JSON.stringify(tempData));
      }
      
      // TODO: the purpose of the code below is unclear since it should change and the array of the removed components
      if (
        javascript.file !== undefined &&
        javascript.file !== '' &&
        javascript.file !== ' ' &&
        javascript.file !== null
      ) {
        const javascriptFunctionIds = javascript.functions.map((func) => func.compId);
        if ( (javascriptFunctionIds.includes(compId)  ||  component.attributes.attributes.annotationname )&& javascript.changeJavascript === false) {
          tempData[selectedProject].pages[selectedPage].javascript.changeJavascript = true;
          localStorage.setItem('data', JSON.stringify(tempData));
        }
      }
    }
  });
};

export default removeJavascriptOnDeleteComp;
